// 公用函数

function getParam (name, url) {
  if (!url) url = location.href;
  name = name.replace(/[\[]/, "\\\[").replace(/[\]]/, "\\\]");
  var regexS = "[\\?&]" + name + "=([^&#]*)";
  var regex = new RegExp(regexS);
  var results = regex.exec(url);
  return results == null ? null : results[1];
}
export function getUrlCode (value) {
  let currentUrl = window.location.href
  let code = getParam(value, currentUrl)
  if (value == 'token' && code) {
    localStorage.setItem('token', code)
  }
  return code
}